import axios from "axios";
import { API } from "../service/api-config";

const getToken = () => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.token;
  if (!token) {
    return null;
  }
  return token;
};

export const objectDetectionAPI = {
  getInference(branchId) {
    const token = getToken();
    return axios.get(API.GET_INFERENCE(branchId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getMinifiedProducts(branchId) {
    const token = getToken();
    return axios.get(API.GET_MINIFIED_PRODUCTS(branchId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};

export const feedbackAPI = {
  createFeedback(branchId, data) {
    const token = getToken();
    return axios.post(API.CREATE_FEEDBACK(branchId), data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};

export const profileAPI = {
  getProfile(userId) {
    const token = getToken();
    return axios.get(API.GET_PROFILE(userId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  updateProfile(userId, data) {
  const token = getToken();
  return axios.put(API.UPDATE_PROFILE(userId), data, {
    headers: {
      Authorization: `Bearer ${token}`
    },
  });
}
};


export const assetAPI = {
  createAsset(data) {
    const token = getToken();
    return axios.post(API.CREATE_ASSET(), data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  uploadAsset(endPoint, data) {
  return axios.put(API.UPLOAD_ASSET(endPoint), data, {
    headers: {
      'Content-Type': data.type || 'application/octet-stream',
    },
  });
}
};

export const couponAPI = {
  getAllCoupons() {
    const token = getToken();
    return axios.get(API.GET_ALL_COUPONS(), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  redeemCoupon(data) {
    const token = getToken();
    return axios.post(API.REDEEM_COUPON(), data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getCoupon(couId) {
    const token = getToken();
    return axios.get(API.GET_COUPON(couId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};
